import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MarkdownModule, MARKED_OPTIONS, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { ChatContainerComponent } from '@nimbus-global/features/chat/components/chat-container/chat-container.component';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { ChatWidgetComponent } from '@nimbus-global/features/chat/components/chat-widget/chat-widget.component';
import { ChatMessagesComponent } from '@nimbus-global/features/chat/components/chat-messages/chat-messages.component';
import { ChatInputMessageComponent } from '@nimbus-global/features/chat/components/chat-input-message/chat-input-message.component';
import { UIModule } from '@nimbus-global/features/ui/ui.module';
import { ChatFormatPipe } from '@nimbus-global/features/chat/components/chat-messages/chat-format.pipe';
import { ChatTruncatePipe } from '@nimbus-global/features/chat/components/chat-messages/chat-truncate.pipe';
import { ChatMarkdownTruncatePipe } from '@nimbus-global/features/chat/components/chat-messages/chat-markdown-truncate.pipe';

@NgModule({
  declarations: [ChatContainerComponent, ChatWidgetComponent, ChatMessagesComponent, ChatInputMessageComponent],
  imports: [
    CommonModule,
    UIModule,
    SharedUIModule,
    ReactiveFormsModule,
    InfiniteScrollDirective,
    TranslateModule,
    ChatFormatPipe,
    ChatTruncatePipe,
    ChatMarkdownTruncatePipe,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: (): MarkedOptions => {
          const renderer = new MarkedRenderer();
          renderer.link = ({ href, title, tokens }): string => {
            const text = tokens.map((token) => token.raw).join('');
            return `<a href="${href}" target="_blank" rel="noopener noreferrer"${title ? ` title="${title}"` : ''}>${text}</a>`;
          };
          return { renderer };
        },
      },
    }),
  ],
  exports: [ChatContainerComponent, ChatWidgetComponent, ChatInputMessageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChatModule {}
